import _ from 'lodash'

import {
  ANSWER_ASSESSMENT_QUESTION,
  INIT_ASSESSMENT_ANSWERS,
  RESET_ASSESSMENT_ANSWERS,
} from './actions'
import type { AssessmentQuestion } from './actions'

export interface AnswerState {
  answered: boolean
  choiceId: string | null
}

export type AssessmentAnswersState = Record<string, AnswerState>

export const initialState = (): AssessmentAnswersState => ({})

type Action =
  | ReturnType<typeof import('./actions').initAnswers>
  | ReturnType<typeof import('./actions').answerQuestion>
  | ReturnType<typeof import('./actions').resetAnswers>

export default function root(
  state: AssessmentAnswersState = initialState(),
  action: Action,
): AssessmentAnswersState {
  switch (action.type) {
    case INIT_ASSESSMENT_ANSWERS:
      return _.reduce(
        action.payload.questions,
        (result: AssessmentAnswersState, question: AssessmentQuestion) => {
          result[question.id] = {
            answered: false,
            choiceId: null,
          }
          return result
        },
        {},
      )

    case ANSWER_ASSESSMENT_QUESTION:
      return {
        ...state,
        [action.payload.question.id]: {
          ...state[action.payload.question.id],
          answered: true,
          choiceId: action.payload.choiceId,
        },
      }

    case RESET_ASSESSMENT_ANSWERS:
      return _.mapValues(state, () => ({
        answered: false,
        choiceId: null,
      }))

    default:
      return state
  }
}
